import React, { memo } from 'react'

import { MoreHoriz } from '@material-ui/icons'

import UserOptionsMenu from '../UserOptionsMenu'
import CurrentUserOptionsMenu from '../CurrentUserOptionsMenu'

import useUserOptions from './useUserOptions'
import { StyledUserOptionsButton } from './styles'
import { PluginUser } from '../../types'

interface UserOptionsProps {
  user: PluginUser
}

const UserOptions: React.FC<UserOptionsProps> = ({ user }) => {
  const {
    enabled,
    isCertificatesMenuVisible,
    isDeviceMenuVisible,
    isHealthInfoOptionsVisible,
    isCurrentUserOptionsVisible,
    isVisible,
    buttonRef,
    open,
    onOpen,
    onClose,
  } = useUserOptions(user)

  return enabled ? (
    <>
      <StyledUserOptionsButton
        ref={buttonRef as unknown as React.RefObject<HTMLButtonElement>}
        size='small'
        onClick={onOpen}
      >
        <MoreHoriz />
      </StyledUserOptionsButton>
      {isCurrentUserOptionsVisible && (
        <CurrentUserOptionsMenu
          isOpen={open}
          anchorEl={buttonRef.current}
          onClose={onClose}
          isDeviceMenuVisible={isDeviceMenuVisible}
          isHealthInfoOptionsVisible={isHealthInfoOptionsVisible}
          isCertificatesMenuVisible={isCertificatesMenuVisible}
        />
      )}
      {isVisible && <UserOptionsMenu isOpen={open} anchorEl={buttonRef.current} onClose={onClose} user={user} />}
    </>
  ) : null
}

export default memo(UserOptions)
